import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import EMPAccordion from "../../../shared/components/EMPAccordion/EMPAccordion";
import EMPButton from "../../../shared/components/EMPButton/EMPButton";
import OnboardingPageTitle from "../../../shared/components/OnboardingPageTitle/OnboardingPageTitle";
import ProtectionPlansEpaAccordion from "../../ProtectionPlansEpaAccordion/ProtectionPlansEpaAccordion";
import ProtectionPlansMenuConfigAccordion from "../../ProtectionPlansMenuConfigAccordion/ProtectionPlansMenuConfigAccordion";
import styles from "./OnboardingProtectionPlans.module.scss";
import MotionChevronRightCircle from "../../../shared/Icons/MotionChevronRightCircle";
import accordionStyles from "../../../shared/components/EMPAccordion/EMPAccordionLincoln.module.scss";

const OnboardingProtectionPlans = ({ hasSavedRouteOneId }) => {
  const { t } = useTranslation();

  const [expandedEpa, setExpandedEpa] = useState(false);
  const [expandedMenuConfig, setExpandedMenuConfig] = useState(false);

  const handleEpaAccordionChange = () => {
    setExpandedEpa((previousExpanded) => !previousExpanded);
  };

  const handleMenuConfigAccordionChange = () => {
    setExpandedMenuConfig((previousExpanded) => !previousExpanded);
  };

  return (
    <div className="tw-bg-white tw-rounded-lg tw-p-8">
      <OnboardingPageTitle
        testId="protection-plans-page-title"
        className="tw-mb-6"
      >
        {t("DealerOnboarding.content.protectionPlans.title")}
      </OnboardingPageTitle>

      <EMPButton
        target="_blank"
        rel="noopener noreferrer"
        className={styles.setupChecklistButton}
        testId="protection-plans-setup-checklist-button"
        variant="outlined"
        hasRightIcon
        rightIcon={<MotionChevronRightCircle />}
      >
        {t("DealerOnboarding.content.protectionPlans.setupChecklistButton")}
      </EMPButton>

      <Box data-testid="onboarding-protection-plans">
        <EMPAccordion
          heading={t("DealerOnboarding.content.protectionPlans.epa.title")}
          headingClassName={accordionStyles.accordionHeading}
          expanded={expandedEpa}
          onChange={handleEpaAccordionChange}
          prefixIconType="caution"
          toggleIconColor="grey"
        >
          <ProtectionPlansEpaAccordion
            hasSavedRouteOneId={hasSavedRouteOneId}
          />
        </EMPAccordion>

        <EMPAccordion
          heading={t(
            "DealerOnboarding.content.protectionPlans.menuConfig.title"
          )}
          headingClassName={accordionStyles.accordionHeading}
          expanded={expandedMenuConfig}
          onChange={handleMenuConfigAccordionChange}
          prefixIconType="caution"
          toggleIconColor="grey"
        >
          <ProtectionPlansMenuConfigAccordion />
        </EMPAccordion>
      </Box>
    </div>
  );
};

OnboardingProtectionPlans.propTypes = {
  hasSavedRouteOneId: PropTypes.bool,
};

OnboardingProtectionPlans.defaultProps = {
  hasSavedRouteOneId: false,
};

export default OnboardingProtectionPlans;
